import {Component, Input} from '@angular/core';

import {AbstractFieldComponent} from '../_abstract/abstract-field.component';

@Component({
    selector: 'field-input',
    templateUrl: './field-input.component.html',
    styleUrls: [
        './field-input.component.scss',
    ],
    standalone: false
})
export class FieldInputComponent extends AbstractFieldComponent {
  @Input() public type = 'text';
}
